import { useRef, useState } from "react";
import clsx from "clsx";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import styles from "./index.module.scss";

export default function SliderMobile({ images }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef();
  return (
    <div className={styles.SliderMobile}>
      <div>
        <Swiper
          className={styles.Swiper}
          ref={sliderRef}
          watchSlidesProgress={true}
          navigation={true}
          slidesPerView={1}
          modules={[Navigation]}
          onActiveIndexChange={(swiper) => {
            setActiveIndex(swiper.activeIndex);
          }}
        >
          {images.map((item, index) => (
            <SwiperSlide key={index}>
              {item.isVideo ? (
                <iframe
                  src={item.full}
                  frameBorder={0}
                  allowFullScreen="allowfullscreen"
                ></iframe>
              ) : (
                <img src={item.small} alt={""} />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={styles.Thumbs}>
        {images.map((image, index) => (
          <span
            key={index}
            onClick={() => {
              setTimeout(() => {
                sliderRef.current.swiper.slideTo(index);
              });
            }}
            style={{ backgroundImage: `url(${image?.thumb})` }}
            className={clsx(
              styles.Thumb,
              activeIndex === index && styles.ThumbActive,
            )}
          ></span>
        ))}
      </div>
    </div>
  );
}
